
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace-analytics-mcp",
      function () {
        return require("private-next-pages/marketplace-analytics-mcp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace-analytics-mcp"])
      });
    }
  